import React from 'react';
import { PieChart as RechartsPieChart, Pie, Cell } from 'recharts';
import { ISimplePieChart } from '../SimpleChartEngine/types';
import { ChartContainer, ChartLegend, ChartTooltip } from '@/components/ui/chart';
import { AIChartEngineCustomLegendContent, AIChartEngineCustomTooltipContent, generateChartParams } from '../SimpleChartEngine/SimpleChartEngine';
import { SimpleChartCardWrapper } from './SimpleChartCardWrapper';

export const SimplePieChart: React.FC<ISimplePieChart> = (props) => {
  const { data, innerRadius, outerRadius, legendVerticalAlign, legendHorizontalAlign, legendLayout } = props;

  const { chartColors, chartConfig, chartOptions } = generateChartParams(props);

  const renderCustomLabel = (
    { cx = 0, cy = 0, midAngle = 0, innerRadius = 0, outerRadius = 0, percent = 0 }:
      { cx?: number; cy?: number; midAngle?: number; innerRadius?: number; outerRadius?: number; percent?: number }
  ) => {
    if (!chartOptions.showLabels) return null;

    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
        fontSize={12}
        fontWeight="bold"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <SimpleChartCardWrapper {...props}>
      <ChartContainer
        config={chartConfig}
        style={{ maxHeight: chartOptions.maxHeight, minHeight: chartOptions.minHeight, width: '100%' }}
      >
        <RechartsPieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomLabel}
            outerRadius={outerRadius}
            innerRadius={innerRadius}
            dataKey={chartOptions.valueKey as string}
            nameKey={chartOptions.nameKey as string}
          >
            {data.map((_entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={chartColors[index]}
              />
            ))}
          </Pie>

          <ChartTooltip
            content={
              <AIChartEngineCustomTooltipContent
                options={chartOptions}
                config={chartConfig} />
            }
            cursor={false} />

          {chartOptions.showLegend && (
            <ChartLegend
              content={
                <AIChartEngineCustomLegendContent
                  // nameKey={nameKey}
                  className="flex-col gap-2 items-start" />
              }
              layout={legendLayout ?? "vertical"}
              verticalAlign={legendVerticalAlign ?? "middle"}
              align={legendHorizontalAlign ?? "right"}
            />
          )}
        </RechartsPieChart>
      </ChartContainer>
    </SimpleChartCardWrapper>
  );
};
